export default "__VITE_ASSET__874917af__"